/**
 * Standalone QR Phone mark (brand guide v1.0): a QR finder-pattern rounded
 * square — the "eye" a scanner locks onto — with its core replaced by the
 * Live Green dot of an active call. No master-brand endorsement, no byline.
 */

type BrandLockupProps = {
  /** 'light' = ink on a light card (default); 'dark' = white on a dark stage. */
  tone?: 'light' | 'dark'
}

/** QR finder-pattern symbol: ink square, paper ring, Live Green dot core. */
function QrPhoneMark({ tone }: { tone: 'light' | 'dark' }) {
  const squareFill = tone === 'dark' ? '#F6F4ED' : '#16191C'
  const ringStroke = tone === 'dark' ? '#16191C' : '#F6F4ED'

  return (
    <svg className="cf-lockup-symbol" viewBox="0 0 48 48" fill="none" aria-hidden="true" focusable="false">
      <rect x="0" y="0" width="48" height="48" rx="12" fill={squareFill} />
      <rect x="10" y="10" width="28" height="28" rx="7" fill="none" stroke={ringStroke} strokeWidth="5" />
      <circle cx="24" cy="24" r="6" fill="#16C47F" />
    </svg>
  )
}

export default function BrandLockup({ tone = 'light' }: BrandLockupProps) {
  return (
    <div className={`cf-lockup cf-lockup-${tone}`}>
      <QrPhoneMark tone={tone} />
      <span className="cf-lockup-text">
        <span className="cf-lockup-name">QR Phone</span>
      </span>
    </div>
  )
}
